import { hubspot } from "../data/site";

const endpoint = (formId) =>
  `https://api.hsforms.com/submissions/v3/integration/submit/${hubspot.portalId}/${formId}`;

/**
 * Submit to one of our HubSpot forms (see `hubspot` in data/site.js) from
 * the browser. HubSpot's public submissions API needs no key and allows
 * cross-origin posts. `fields` maps HubSpot property names to values; empty
 * values are left out. Throws when HubSpot rejects or can't be reached.
 */
export async function submitHubSpotForm(form, fields) {
  const response = await fetch(endpoint(hubspot.forms[form]), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      fields: Object.entries(fields)
        .filter(([, value]) => value)
        .map(([name, value]) => ({ name, value })),
      context: { pageUri: window.location.href, pageName: document.title },
    }),
  });
  if (!response.ok) {
    const detail = await response.json().catch(() => ({}));
    throw new Error(detail.message || `HubSpot responded ${response.status}`);
  }
}
